"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var defaultApiCall = function (url, apiOptions) {
    return new Promise(function (resolve, reject) {
        fetch(url, apiOptions)
            .then(function (response) {
            // eslint-disable-line arrow-body-style
            return response.json().then(function (result) { return [response.status, result]; });
        })
            .then(function (_a) {
            var _b = __read(_a, 2), status = _b[0], result = _b[1];
            if (status >= 200 && status < 400) {
                resolve(result);
                return;
            }
            if (status >= 400) {
                reject({
                    status: status,
                    result: result,
                });
                return;
            }
            reject({
                status: status,
                result: result,
                Message: "Unknown status: " + status + ", body: " + JSON.stringify(result),
            });
        })
            .catch(function (e) {
            reject({
                status: 408,
                OriginalError: e,
            });
        });
    });
};
/* eslint-disable no-use-before-define */
var defaultAPIServiceCtor = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.baseUrlResolver, baseUrlResolver = _c === void 0 ? function () { return 'https://'; } : _c, _d = _b.apiVersionResolver, apiVersionResolver = _d === void 0 ? function () { return 'v3'; } : _d, _e = _b.headersResolver, headersResolver = _e === void 0 ? function () { return undefined; } : _e, _f = _b.apiCallResolver, apiCallResolver = _f === void 0 ? defaultApiCall : _f;
    return {
        getEvents: getEvents,
        postEvents: postEvents,
        getEventsExamplesByEventVersion: getEventsExamplesByEventVersion,
        validateEvents: validateEvents,
        normalizeEvents: normalizeEvents,
    };
    function getEvents() {
        var url = baseUrlResolver() + "/" + apiVersionResolver() + "/events";
        return apiCall(url, {
            method: 'GET',
        });
    }
    function postEvents(payload, _a) {
        var _b = _a === void 0 ? {} : _a, newHeadersResolver = _b.headersResolver;
        var url = baseUrlResolver() + "/" + apiVersionResolver() + "/events";
        return apiCall(url, {
            method: 'POST',
            headers: newHeadersResolver ? newHeadersResolver() : headersResolver(),
            body: typeof payload === 'string' ? payload : JSON.stringify(payload),
        });
    }
    function getEventsExamplesByEventVersion(_a) {
        var _b = _a === void 0 ? {} : _a, eventVersion = _b.eventVersion;
        var url = baseUrlResolver() + "/" + apiVersionResolver() + "/events/examples/" + eventVersion;
        return apiCall(url, {
            method: 'GET',
        });
    }
    function validateEvents(payload) {
        var url = baseUrlResolver() + "/" + apiVersionResolver() + "/events/validate";
        return apiCall(url, {
            method: 'POST',
            body: typeof payload === 'string' ? payload : JSON.stringify(payload),
        });
    }
    function normalizeEvents(payload, _a) {
        var _b = _a === void 0 ? {} : _a, newHeadersResolver = _b.headersResolver;
        var url = baseUrlResolver() + "/" + apiVersionResolver() + "/events/validate";
        return apiCall(url, {
            method: 'POST',
            headers: newHeadersResolver ? newHeadersResolver() : headersResolver(),
            body: typeof payload === 'string' ? payload : JSON.stringify(payload),
        });
    }
    function apiCall(url, apiOptions) {
        return apiCallResolver(url, __assign(__assign({ mode: 'cors' }, apiOptions), { headers: __assign(__assign({}, (apiOptions.headers || {})), { Accept: 'application/json', 'Content-Type': 'application/json' }) }));
    }
};
exports.default = defaultAPIServiceCtor;
//# sourceMappingURL=index.js.map